<template>
  <div>
    <!--
    <div>loadings</div>
    <div 
      v-for="(loading, key) in loadings"
      :key="`loading_${key}`">{{ key }}:[{{ loading }}]
    </div>
    <div>dbErrors</div>
    <div 
      v-for="(dbError, key) in dbErrors"
      :key="`dbError_${key}`">:[{{ dbError }}]
    </div>
    <div>clubUsers[{{ clubUsers }}]</div>
    <div>isClubAdmin[{{ isClubAdmin }}]</div>
    <div>isClubEditor[{{ isClubEditor }}]</div>
    <div>isLoggedUser[{{ isLoggedUser }}]</div>
    -->
    <template v-if="isLoading">
      <Loading />
    </template>
    <template v-else-if="hasDbError">
      <Error v-for="(error, key) in dbErrors" v-if="error" :key="key" error="error" />
    </template>
    <template v-else>
      <AdminButton
        v-if="isClubAdmin"
        @editClub="editClubAction"
        @editSponsors="navigateTo({ name: 'ClubSponsors', params: { clubId } })"
        @createMatch="createMatch"
        @createMatchMultiple="
          navigateTo({ name: 'ClubAddMatches', params: { clubId, year, week } })
        "
        @adminUsers="navigateTo({ name: 'ClubUsers', params: { clubId } })"
      />
      <BaseFormModal
        v-if="menuOpenClub"
        :item="club"
        :model="clubModel"
        :menu-open.sync="menuOpenClub"
        entity="club"
        @onAdd="onAddClub"
        @onUpdate="onUpdateClub"
      />
      <BaseFormModal
        v-if="menuOpenMatch"
        :item="null"
        :model="matchModel"
        :menu-open.sync="menuOpenMatch"
        entity="match"
        @onAdd="onAddMatch"
        @onUpdate="onUpdateMatch"
      />
      <div>
        <div class="teams">
          <WeekNavigate
            :year="year"
            :week="week"
            @movePrevWeek="movePrevWeek"
            @moveNextWeek="moveNextWeek"
          />
          <BaseTable
            :page="page"
            :entity="entity"
            :items="items"
            :model="matchModel"
            :admin-mode="isClubAdmin"
            :allow-add="false"
            :allow-edit="isClubAdmin"
            :allow-go="false"
            :allow-delete="isClubAdmin"
            @onAdd="onAddMatch"
            @onUpdate="onUpdateMatch"
            @onDelete="onDeleteMatch"
            @onGo="onGoMatch"
          >
            <MatchCard
              v-if="sport"
              slot="card"
              slot-scope="{ item }"
              :match="item"
              :club="club"
              :sport="sport"
              :admin-mode="isClubAdmin"
              :editor-mode="isClubEditor"
              :viewer-mode="isClubViewer"
              :logged-mode="isLoggedUser"
              :display-charts="false"
              @onUpdate="onUpdateMatch"
              @onGo="onGoMatch"
              @onAddPlayer="onAddPlayer"
              @onSendEvent="onSendEvent"
              @onToogleBlockMatch="onToogleBlockMatch"
              @onRemoveLastEvent="onRemoveLastEvent"
              @onAddComment="onAddComment"
              @onRemoveComment="onRemoveComment"
              @onDeleteMatch="onDeleteMatch"
            />
            <template slot="customFilter">
              <div>
                <v-checkbox
                  :label="$t('general.filter.onlyActives')"
                  v-model="checkboxOnlyActives"
                />
              </div>
            </template>
          </BaseTable>
        </div>
      </div>
      <Sponsors v-if="clubSponsors && clubSponsors.length > 0" :sponsors="clubSponsors" />
    </template>
  </div>
</template>

<script>
import _ from 'lodash'
import ClubsLib from '@/lib/data/clubs'
import MatchesLib from '@/lib/data/matches'
import ClubUsersLib from '@/lib/data/clubUsers'
import ClubSponsorsLib from '@/lib/data/clubSponsors'
import BaseMixin from '@/components/Dashboard/Mixin/BaseMixin'
import Loading from '@/components/UIComponents/Loading/Loading'
import Error from '@/components/UIComponents/Error/Error'
import clubModel from '@/lib/data/models/club'
import matchModel from '@/lib/data/models/match'
import MatchHelper from '@/lib/MatchHelper'
import SportHelper from '@/lib/SportHelper'
import MetaHelper from '@/lib/MetaHelper'
import DateHelper from '@/lib/DateHelper'
import SecurityHelper from '@/lib/SecurityHelper'
import BaseTable from '@/components/Base/BaseTable'
import MatchCard from '@/components/Dashboard/Views/Club/Views/WeekMatches/Views/Match/Templates/MatchCard'
import Sponsors from '@/components/Dashboard/Views/Club/Views/WeekMatches/Views/Match/Templates/Sponsors'
import BaseFormModal from '@/components/Base/BaseFormModal'
import AdminButton from '@/components/Dashboard/Views/Club/Views/WeekMatches/Templates/AdminButton'
import WeekNavigate from '@/components/Dashboard/Views/Club/Views/WeekMatches/Templates/WeekNavigate'
const debug = require('debug')('OD::WeekMatches')

export default {
  name: 'WeekMatches',
  components: {
    BaseTable,
    Sponsors,
    MatchCard,
    BaseFormModal,
    Loading,
    Error,
    AdminButton,
    WeekNavigate,
  },
  mixins: [BaseMixin],
  props: {
    clubId: {
      type: String,
      required: true,
    },
    year: {
      type: String,
      required: true,
    },
    week: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      storeModule: 'matches',
      storeModuleSingle: 'match',
      menuOpen: false,
      direction: 'top',
      fab: false,
      fling: false,
      hover: false,
      tabs: null,
      transition: 'slide-y-reverse-transition',
      menuOpenClub: false,
      menuOpenMatch: false,

      page: 'matches',
      entity: 'match',
      club: null,
      matches: [],
      clubUsers: [],
      clubSponsors: [],
      loadings: {
        club: true,
        matches: false,
        clubUsers: true,
        clubSponsors: true,
      },
      dbErrors: {
        club: null,
        matches: null,
        clubusers: null,
        clubSponsors: null,
      },
      checkboxOnlyActives: false,
    }
  },
  computed: {
    getIniDate() {
      return this.getDateOfISOWeek(this.week, this.year)
    },
    weekDates() {
      const dates = DateHelper.getWeekDates(this.year, this.week)
      return { firstDay: dates[0], lastDay: dates[6] }
    },
    clubModel() {
      return clubModel
    },
    matchModel() {
      return matchModel
    },
    isLoggedUser(currentUser) {
      return SecurityHelper.isLoggedUser(this.currentUser)
    },
    isClubAdmin(currentUser, clubUsers, clubId) {
      return SecurityHelper.isClubAdmin(this.currentUser, this.clubUsers, this.clubId)
    },
    isClubEditor(currentUser, clubusers, clubId) {
      return SecurityHelper.isClubEditor(this.currentUser, this.clubUsers, this.clubId)
    },
    isClubViewer(currentUser, clubusers, clubId) {
      return SecurityHelper.isClubViewer(this.currentUser, this.clubUsers, this.clubId)
    },
    isLoading() {
      return _.values(this.loadings).filter(loading => loading).length > 0
    },
    hasDbError() {
      return _.values(this.dbErrors).filter(error => error && error !== '').length > 0
    },
    items() {
      let matches = this.matches.slice(0)
      if (this.checkboxOnlyActives) {
        matches = matches.filter(match => {
          const config = this.config(match)
          const result = MatchHelper.getMatchResult(config, match)
          const isMatchFinish = MatchHelper.isMatchFinish(config, match, result)
          return MatchHelper.isMatchOnline(config, match, isMatchFinish)
        })
      }
      return matches.sort((a, b) => parseInt(a.order) - parseInt(b.order))
    },
    sport() {
      if (this.match && this.match.sport) return SportHelper.getSportConfiguration(this.match.sport)
      return SportHelper.getSportConfiguration(this.club.sport)
    },
  },
  watch: {
    clubId() {
      this.bind()
    },
    year() {
      this.bind()
    },
    week() {
      this.bind()
    },
    club() {
      if (this.club) {
        this.$emit('updateHead')
      }
    },
  },
  created() {
    debug('created')
    this.bind()
  },
  mounted() {},
  beforeDestroy() {},
  methods: {
    bind() {
      ClubsLib.bindItem(this, { clubId: this.clubId })
      ClubUsersLib.bindAll(this, { clubId: this.clubId })
      ClubSponsorsLib.bindAll(this, { clubId: this.clubId })
      MatchesLib.bindAll(this, { clubId: this.clubId, year: this.year, week: this.week })
    },
    config(match) {
      return MatchHelper.config(this.sport)
    },
    movePrevWeek(data) {
      this.$router.push({
        name: 'WeekMatches',
        params: {
          clubId: this.clubId,
          year: `${data.year}`,
          week: `${data.week}`,
        },
      })
    },
    moveNextWeek(data) {
      this.$router.push({
        name: 'WeekMatches',
        params: {
          clubId: this.clubId,
          year: `${data.year}`,
          week: `${data.week}`,
        },
      })
    },
    editClubAction() {
      this.menuOpenClub = true
    },
    createMatch() {
      this.menuOpenMatch = true
    },
    onAddClub(newItem) {
      debug('onAddClub', newItem)
      ClubsLib.add(this, this.currentUser, newItem)
    },
    onUpdateClub(newItem, item) {
      debug('onUpdateClub', newItem, item)
      ClubsLib.update(this, this.currentUser, newItem, item)
    },
    async onAddMatch(newItem) {
      debug('onAddMatch', newItem)
      debug('onAddMatch', { sport: this.sport.sport, new: newItem.sport })
      let sport = _.cloneDeep(this.sport)
      if (this.sport.name !== newItem.sport) {
        debug('onAddMatch', 'entro')
        sport = SportHelper.getSportConfiguration(newItem.sport)
      }
      debug('onAddMatch', { sport })
      debug('onAddMatch', { sport: sport.sport })
      await MatchesLib.add(this, this.currentUser, newItem, this.club, sport, {
        clubId: this.clubId,
        year: this.year,
        week: this.week,
      })
    },
    async onUpdateMatch(newItem, item) {
      debug('onUpdateMatch', newItem, item)
      await MatchesLib.update(this, this.currentUser, this.club, this.sport, item, newItem)
    },
    async onDeleteMatch(item) {
      debug('onDeleteMatch', item)
      await MatchesLib.delete(this, this.currentUser, item)
    },
    onGoMatch(item) {
      debug('onGoMatch', item)
      this.navigateTo({
        name: 'Match',
        params: {
          clubId: item.clubId,
          year: item.year,
          week: item.week,
          matchId: item.id,
        },
      })
    },
    async onAddPlayer(data) {
      await MatchesLib.addPlayer(this, this.currentUser, this.club, this.sport, data)
    },
    async onSendEvent(data) {
      await MatchesLib.sendEvent(this, this.currentUser, this.club, this.sport, data)
    },
    async onRemoveLastEvent(data) {
      await MatchesLib.removeLastEvent(this, this.currentUser, this.club, this.sport, data)
    },
    async onToogleBlockMatch(data) {
      await MatchesLib.toogleBlockMatch(this, this.currentUser, this.club, this.sport, data)
    },
    async onAddComment(data) {
      await MatchesLib.addComment(this, this.currentUser, this.club, this.sport, data)
    },
    async onRemoveComment(data) {
      await MatchesLib.removeComment(this, this.currentUser, this.club, this.sport, data)
    },
  },
  head: {
    title: function() {
      return MetaHelper.getClubTitle(this.clubId, this.club, 'weekMatches')
    },
    meta: function() {
      return MetaHelper.getClubMeta(this.clubId, this.club, 'weekMatches', {
        name: 'WeekMatches',
        params: { clubId: this.clubId, year: this.year, week: this.week },
      })
    },
  },
}
</script>

<style lang="scss">
/*
.custom-btn-toggle {
  .btn {
    opacity: 1;
  }
}
#create .speed-dial {
  position: absolute;
}

#create .btn--floating {
  position: relative;
}
.speed-dial {
  z-index: 1000;
}
.speed-dial--bottom:not(.speed-dial--absolute) {
  // bottom: 45px;
}
*/
</style>
